module.exports = __webpack_public_path__ + "static/img/img5.87dcb748.png";